export default {
    DEFAULT_IMPRESSION: {
        out_of_session: false,
        group: 'user_impressions',
        sub_group: 'content_impression',
        type: 'reviews_header_is_shown',
        publisher: {
            domain: 'algos',
            sub_domain: 'quality',
        },
        action: {
            type: 'impression',
        },
        feature: {
            name: 'gig_reviews',
        },
    },
};
